<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { AIRPORT, REGION, SUB_REGION } from '@/constants';
import Checkbox from 'primevue/checkbox';

interface Props {
  applicability?: any;
  referenceType?: string;
  isReferenceType?: boolean;
}
const props = defineProps<Props>();

const { t } = useI18n({ useScope: 'global' });
const typeValue = computed(() => handleRenderType());

const referenceTypeList = ref([
  {
    label: t('common.airport'),
    type: AIRPORT
  },
  {
    label: t('common.region'),
    type: REGION
  },
  {
    label: t('common.sub_region'),
    type: SUB_REGION
  }
]);

const handleRenderType = () => {
  return props.isReferenceType ? formatReferenceType() : formatTypeApplicability();
};

const formatTypeApplicability = () => {
  return [
    {
      label: t('common.package'),
      value: props.applicability.isPackage
    },
    {
      label: t('common.air'),
      value: props.applicability.isAir
    },
    {
      label: t('common.hotel'),
      value: props.applicability.isHotel
    },
    {
      label: t('common.cruise'),
      value: props.applicability.isCruise
    },
    {
      label: t('common.tour'),
      value: props.applicability.isTour
    }
  ];
};

const formatReferenceType = () => {
  return referenceTypeList.value
    .filter((referenceType: any) => referenceType.type === props.referenceType)
    .map((referenceType: any) => {
      return {
        ...referenceType,
        value: true
      };
    });
};
</script>

<template>
  <div class="min-w-160">
    <div class="type-view">
      <div v-for="(type, index) in typeValue" :key="index" class="mb-1">
        <Checkbox :id="type.label" v-model="type.value" disabled :binary="true" />
        <label :for="type.label" class="ml-2">{{ type.label }}</label>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.min-w-160 {
  min-width: 160px !important;
  width: 100%;
}
</style>
